// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalContentFull-module-wrapper","content":"ModalContentFull-module-content","white":"ModalContentFull-module-white","none":"ModalContentFull-module-none"};